export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <h3 className="text-xl font-heading text-background-50 mb-4">小草影院</h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              小草影院免费在线看电影电视剧，全站资源不收费、不缓冲秒开播。无需注册即点即看，流畅观影体验尽在小草影视。每日更新热门大片与经典佳作，覆盖动作、喜剧、科幻、爱情、悬疑等多种题材，致力于为每一位观众提供最便捷的免费高清观影服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#ranking" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">热门榜单</a></li>
              <li><a href="#cards" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">热门推荐</a></li>
              <li><a href="#updates" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">最新动态</a></li>
              <li><a href="#faq" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">常见问答</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              <li><a href="#topics" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">热门话题</a></li>
              <li><a href="#index" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">专题合集</a></li>
              <li><a href="#media" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">精彩影音</a></li>
              <li><a href="#carousel" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">焦点专题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400">优质合作伙伴招募中，敬请期待。</p>
            <div className="mt-6">
              <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"><i className="ri-wechat-line text-lg"></i></span>
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"><i className="ri-weibo-line text-lg"></i></span>
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"><i className="ri-bilibili-line text-lg"></i></span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 小草影院 版权所有 | 本站所有资源均来自网络，仅供学习交流
          </p>
          <div className="flex items-center gap-5">
            <span className="text-xs text-foreground-400 hover:text-background-200 transition-colors cursor-pointer">免责声明</span>
            <span className="text-xs text-foreground-400 hover:text-background-200 transition-colors cursor-pointer">隐私政策</span>
            <span className="text-xs text-foreground-400 hover:text-background-200 transition-colors cursor-pointer">用户协议</span>
          </div>
        </div>
      </div>
    </footer>
  );
}